var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecureWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M107.443 16.0947C107.237 14.612 106.17 13.3924 104.728 12.9915L58.5072 0.137549C57.8483 -0.0458497 57.1522 -0.0458497 56.4928 0.137549L10.2723 12.9915C8.8302 13.3924 7.76338 14.6115 7.55693 16.0947C7.28885 18.0224 1.17306 63.5694 16.8597 86.2277C32.5277 108.859 55.6415 114.659 56.6176 114.895C56.9077 114.965 57.2034 114.999 57.5 114.999C57.7967 114.999 58.0923 114.964 58.3824 114.895C59.3591 114.659 82.4728 108.859 98.1404 86.2277C113.827 63.5699 107.711 18.0229 107.443 16.0947ZM87.3063 42.6855L55.7793 74.2126C55.0457 74.9462 54.0836 75.3135 53.122 75.3135C52.1604 75.3135 51.1983 74.9467 50.4647 74.2126L30.9718 54.7197C30.2668 54.0152 29.8709 53.0591 29.8709 52.0624C29.8709 51.0658 30.2673 50.1097 30.9718 49.4052L34.8422 45.5347C36.3099 44.0676 38.6896 44.067 40.1568 45.5347L53.122 58.4999L78.1213 33.5001C78.8259 32.795 79.7819 32.3992 80.7786 32.3992C81.7753 32.3992 82.7314 32.795 83.4359 33.5001L87.3063 37.3705C88.774 38.8382 88.774 41.2178 87.3063 42.6855Z",
    fill: "#C32A7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureWarning);
export default __webpack_public_path__ + "static/media/secure_warning.6b8ad67915491748b4eefcdd1e2784f7.svg";
export { ForwardRef as ReactComponent };